<template>
  <div>
    <AuthHeading
        :title="title"
        sub-title="Enter your Email below and we get you back on track."
    />
    <AuthForm is-reset-password-send-email />
  </div>
</template>

<script>
import AuthHeading from '@/components/auth/AuthHeading';
import AuthForm from '@/components/auth/AuthForm';

export default {
  components: {
    AuthHeading,
    AuthForm,
  },
  props: {
    title: {
      default: 'Reset your password.',
    },
  },
};
</script>

<style scoped>
</style>
